import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import PartnershipForm from "@/components/PartnershipForm";
import { Reveal } from "@/components/motion/Reveal";
import { PARTNERSHIP_CATEGORIES, IMAGES } from "@/lib/content";

export default function Partnerships() {
  return (
    <>
      <Seo title="Partnerships" path="/partnerships" description="Build impact with us. Planet Trotter Foundation seeks CSR, conservation, research, educational, community and institutional partnerships in India and worldwide." />
      <PageHero
        eyebrow="Partnerships"
        titleLines={["Build impact", "with us."]}
        intro="What your organisation can build with the Foundation: CSR programmes, conservation projects, research and community work, with clear terms and honest reporting."
        image={IMAGES.river}
      />

      {/* Categories */}
      <section className="bg-ptf-bg py-24 md:py-32">
        <div className="mx-auto max-w-[1600px] px-5 sm:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-ptf-primary/10 border border-ptf-primary/10">
            {PARTNERSHIP_CATEGORIES.map((c, i) => (
              <Reveal key={c.title} delay={(i % 3) * 0.06} className="h-full">
                <div className="group bg-ptf-bg p-8 h-full transition-colors duration-500 hover:bg-ptf-primary">
                  <span className="font-display text-2xl text-ptf-primary/30 group-hover:text-ptf-accent transition-colors">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display uppercase text-2xl tracking-tight text-ptf-primary group-hover:text-ptf-bg transition-colors mt-4 leading-none">{c.title}</h3>
                  <p className="mt-4 text-sm text-ptf-text/70 group-hover:text-ptf-bg/70 transition-colors leading-relaxed">{c.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Enquiry form */}
      <section id="enquiry" className="bg-ptf-primary text-ptf-bg py-24 md:py-32 grain relative scroll-mt-24">
        <div className="relative z-10 mx-auto max-w-[1600px] px-5 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="text-[0.7rem] uppercase tracking-[0.28em] text-ptf-accent mb-6 flex items-center gap-3">
              <span className="h-px w-8 bg-ptf-accent inline-block" /> Enquiry
            </p>
            <h2 className="font-display font-extrabold uppercase text-4xl md:text-5xl leading-[0.92] tracking-tight">Start a conversation.</h2>
            <p className="mt-6 text-ptf-bg/75 leading-relaxed">
              Tell us who you are and what you'd like to build. Our team will respond as
              we develop our programmes and collaborations.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Reveal>
              <div className="border border-ptf-bg/15 p-7 md:p-10">
                <PartnershipForm dark />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
